import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DateModel, Field } from 'src/app/models/field';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css']
})
export class DateComponent implements OnInit {

  constructor(private datePipe: DatePipe){

  }


  ngOnInit(): void {

    this.minDate = this.field.minDate?.date!=""? this.processDate(this.field.minDate!):undefined;
    this.defaultDate = this.field.defaultDate?.date !="" ? this.processDate(this.field.defaultDate!):undefined;
    this.maxDate = this.field.maxDate?.date!="" ? this.processDate(this.field.maxDate!) :undefined;
    
    if(this.value){
      this.date=this.formatDate(this.value);
    }else{
      if(this.defaultDate){
        this.date=this.formatDate(this.defaultDate);
      }
    }
  }

  formatDate(dateString: string): string {
    // Directly use the dateString to create a Date object since it's in ISO 8601 format
    const dateObj = new Date(dateString);
  
    // Use the DatePipe to transform the Date object to 'yyyy-MM-dd'
    return this.datePipe.transform(dateObj, 'yyyy-MM-dd')!;
  }

  @Input() formGroup: UntypedFormGroup|undefined;

  @Input()
  field!: Field;

  @Input()
  isUserType:boolean=false;

  @Input()
  fieldId:string|undefined;

  @Input()
  yourTurn:boolean|undefined;

  @Input()
  submitted:boolean|undefined;

  @Input()
  control!: any;

  @Input()
  errors:any;

  @Input({required:true})
  value:any;

  @Input()
  isInvalid:boolean=false;

  @Input()
  containerFieldId:string|undefined=undefined;

  @Input()
  fieldIndex:number|undefined=undefined;

  @Input()
  isContainer:boolean=false;

  defaultDate:string|undefined;
  minDate:string|undefined;
  maxDate:string|undefined;

  date:string="";


  updateIsUserType(){
    if(this.formGroup?.get(this.fieldId!)?.value!="" && this.formGroup?.get(this.fieldId!)?.value!=null){
      this.isUserType=true;
    }else{
      this.isUserType=false;
    }
  }


  @Output() 
  refreshFormEvent:EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>=new EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>();


  refreshForm(fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean){
   // if(this.isUserType){
      this.refreshFormEvent.emit({ fieldId ,shouldRefresh,containerFieldId,fieldIndex,isContainer});
   // }

  }

  processDate(dateObj: DateModel): string {
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in one day

    let currentDate: Date;
    if (!dateObj.date || dateObj.date.toUpperCase() === "NOW") {
        currentDate = new Date();
    } else {
        currentDate = new Date(dateObj.date);
        // Check if the date is valid
        if (isNaN(currentDate.getTime())) {
            throw new Error(`Invalid date format: ${dateObj.date}`);
        }
    }

    const minusDays = parseInt(dateObj.minusDays || '0', 10);
    const plusDays = parseInt(dateObj.plusDays || '0', 10);

    const resultDate = new Date(currentDate.getTime() + (plusDays - minusDays) * oneDay);

    // Check if the result date is valid
    if (isNaN(resultDate.getTime())) {
        throw new Error('Invalid result date after calculations.');
    }
    
    return resultDate.toISOString().split('T')[0];
}




}
